/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@modules/app.module';
import { Chart, registerables } from 'chart.js';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

Chart.register(...registerables);

// Observabilidad (2026-07-31) — GlitchTip (primario, protocolo compatible con Sentry). Se
// inicializa ANTES de bootstrapModule (patrón recomendado por @sentry/angular, para capturar
// también errores que ocurran durante el bootstrap mismo). No-op seguro si environment.glitchTipDsn
// está vacío. El reporte real de errores no capturados sigue pasando por
// RollbarErrorHandlerService (ver ese archivo) — acá solo se inicializa el SDK.
if (environment.glitchTipDsn) {
  Sentry.init({
    dsn: environment.glitchTipDsn,
    environment: environment.entorno,
    tracesSampleRate: 0.2,
    release: environment.buildNumber,
  });
}

// Puente OAuth <-> hash routing (2026-09-01): la app usa useHash:true (ver
// app-routing.module.ts), así que TODAS sus rutas viven después de un "#" (ej.
// localhost:4200/#/eventosagenda). Los proveedores de OAuth, en cambio, NO permiten registrar
// un redirect_uri con "#" (tanto Google Cloud Console como Azure lo rechazan al guardarlo:
// "MUST NOT include a fragment component", RFC 6749 §3.1.2) — así que los redirect_uri
// configurados (GoogleAuth:CalendarRedirectUri / MicrosoftAuth:CalendarRedirectUri en el
// backend) tienen que ser rutas "planas", sin hash:
// http://localhost:4200/calendario/google-callback?code=...
// http://localhost:4200/calendario/outlook-callback?code=...
// Angular con hash routing ignora por completo el path/query de ANTES del "#", así que sin
// este puente esas URLs caen siempre en la ruta por defecto (404) y el "code" se pierde. Antes
// de bootstrapear, si detectamos que aterrizamos justo en una de esas rutas planas con query
// string, reescribimos la URL al equivalente con hash (preservando el query string) y recién
// ahí arrancamos Angular — así el componente de callback la recibe normal, vía ActivatedRoute,
// como cualquier otra ruta.
//
// Auditoria QA (2026-09-11): este puente contemplaba SOLO el callback de Google, hardcodeado.
// La integracion de Outlook (2026-09-01) agrego su ruta en app-routing.module.ts y su
// redirect_uri en appsettings, pero no paso por aca, asi que "Vincular Outlook Calendar"
// terminaba siempre en el 404. Ahora la lista es la unica fuente de verdad: para sumar otro
// proveedor alcanza con agregar su ruta plana.
const RUTAS_CALLBACK_OAUTH = [
  '/calendario/google-callback',
  '/calendario/outlook-callback',
];

function normalizarCallbackOAuthSiHaceFalta(): boolean {
  const { pathname, search, hash } = window.location;

  // Se compara sin la barra final por si el proveedor la agrega al redirigir.
  const rutaPlana = RUTAS_CALLBACK_OAUTH.find(
    ruta => pathname === ruta || pathname === `${ruta}/`
  );

  if (!rutaPlana || !search || hash) {
    return false;
  }

  window.location.replace(`/#${rutaPlana}${search}`);
  return true;
}

if (!normalizarCallbackOAuthSiHaceFalta()) {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
